export enum ReportType {
  DAILY_SUMMARY = 'Daily Tally',
  SHOPPING_LIST = 'Shopping List',
  MEALS_PER_LUNCH_PERIOD = 'Meals Served Per Lunch Period',
  DAILY_COHORT_MEALS = 'Classrooms, Grades, & Staff Report',
}